import { render, staticRenderFns } from "./send-request-modal.vue?vue&type=template&id=96040546&scoped=true"
import script from "./send-request-modal.vue?vue&type=script&lang=js"
export * from "./send-request-modal.vue?vue&type=script&lang=js"
import style0 from "./send-request-modal.vue?vue&type=style&index=0&id=96040546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96040546",
  null
  
)

export default component.exports